import regex from "../constants/Regex";

export const customValidators = [
    {
        ID: "utspassword",
        validate: (input: HTMLInputElement) => {
            return regex.password.test(input.value);
        },
        error: "Please make sure this is has minimum eight characters,<br/>at least one upper case, one lower case, one number and one special character.",
    },
    {
        ID: "customname",
        validate: (input: HTMLInputElement) => {
            return regex.name.test(input.value);
        },
        error: "This field should only contain alphabetical letters and spaces",
    },
    {
        ID: "phonenumber",
        validate: (input: HTMLInputElement) => {
            return regex.phoneNumber.test(input.value);
        },
        error: "Please make sure this is a valid mobile or cell phone number.",
    },
    {
        ID: "utsid",
        validate: (input: HTMLInputElement) => {
            return regex.utsID.test(input.value);
        },
        error: "Please make sure this is a valid UTS ID.",
    },
    {
        ID: "url",
        validate: (input: HTMLInputElement) => {
            return regex.urlRegex.test(input.value);
        },
        error: "Please make sure this is a valid URL.",
    },
    {
        ID: "youtubeurl",
        validate: (input: HTMLInputElement) => {
            return regex.youtubeRegex.test(input.value);
        },
        error: "Please make sure this is a valid YouTube URL.",
    },
    {
        ID: "maxLength500",
        validate: (input: HTMLInputElement) => {
            return input.value.length <= 500;
        },
        error: "This field should be no longer than 500 characters.",
    },
    {
        ID: "maxLength1000",
        validate: (input: HTMLInputElement) => {
            return input.value.length <= 1000;
        },
        error: "This field should be no longer than 1000 characters.",
    },
];
